export default "__VITE_ASSET__BRnVO6xV__"